import React from 'react';
import { FiUpload } from 'react-icons/fi';

export default function PaymentHeader({ onOpenModal }) {
    return (
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div>
                <h2 className="text-2xl font-bold text-gray-900">Payment Center</h2>
                <p className="text-sm text-gray-500">Manage your class deposits and track verification status.</p>
            </div>
            <button
                onClick={onOpenModal}
                className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white font-bold rounded-xl shadow-lg shadow-blue-200 hover:bg-blue-700 transition-all"
            >
                <FiUpload size={18} />
                SUBMIT PAYMENT SLIP
            </button>
        </div>
    );
}
